import React from 'react';
import { Col, Row } from 'reactstrap';
import { nyuAccessibilityUrl, version } from '../../config';

const Footer = () => (
  <footer>
    <Row noGutters className="justify-content-between text-center fs--1 mt-4 mb-3">
      <Col sm="auto">
        <p className="mb-0 text-600">
          INBDE - NYU College of Dentistry <span className="d-none d-sm-inline-block">| </span>
          <br className="d-sm-none" /> {new Date().getFullYear()}
        </p>
      </Col>
      <Col sm="auto">
        <p className="mb-0 text-600">
          <a href={nyuAccessibilityUrl} target="_blank" rel="noopener noreferrer">
            Accessibility<span className="sr-only"> (opens in a new tab)</span>
          </a>
          <span className="mx-2">|</span>v{version}
        </p>
      </Col>
    </Row>
  </footer>
);

export default Footer;
